<script>
import { mapActions, mapState } from 'vuex'
import { config } from '@/config'
import addFile from '@/components/addFile'
import { VueEditor, editorToolbar, showHTMLButton } from '@/terceiros/vue-editor'

export default {
  components: {
    addFile,
    VueEditor
  },
  async created () {
    await this.reload()
    await this.getArquivos()
    await this.getLinks()
    await this.getTags()
    this.cancela()
    showHTMLButton(this.$refs.editor, this.$refs.divEditor)
  },
  data () {
    return {
      url: config.API_URL,
      filtros: {},
      titulo: '',
      form: {
      },
      arquivo: {},
      editorToolbar
    }
  },
  computed: {
    ...mapState({
      arquivos: state => state.arquivo.all,
      links: state => state.link.all,
      tags: state => state.tag.all,
      list: state => state.artigo.list,
      page: state => state.artigo.filtros.page,
      lastPage: state => state.artigo.lastPage
    }),
    paginate () {
      let result = {
        dots_prev: false,
        firstPage: 1,
        page: parseInt(this.page),
        list: [],
        lastPage: parseInt(this.lastPage),
        dots_next: false
      }
      // Cria lista que ira exibir
      let comeca = -2
      let termina = 2
      if (result.page === result.firstPage) {
        comeca = 0
        termina = 4
      } else if (result.page - 1 === result.firstPage) {
        comeca = -1
        termina = 3
      } else if (result.page + 1 === result.lastPage) {
        comeca = -3
        termina = 1
      } else if (result.page === result.lastPage) {
        comeca = -4
        termina = 0
      }
      for (let x = comeca; x <= termina; x++) {
        let p = result.page + x
        if (p >= result.firstPage && p <= result.lastPage) result.list.push(p)
      }
      // Pega primeiro e ultimo item da lista
      let primeiroItem = result.list[0]
      // Valida Prev Next e Dots
      if (primeiroItem > result.firstPage) result.dots_prev = true
      if (result.page !== result.lastPage) result.next = true
      return result
    },
    listTags () {
      if (this.tags) {
        return this.tags.map(i => {
          return {
            id: i.id,
            nome: i.nome
          }
        })
      }
    }
  },
  methods: {
    ...mapActions({
      addArquivo: 'arquivo/add',
      getArquivos: 'arquivo/all',
      getLinks: 'link/all',
      getTags: 'tag/all',
      add: 'artigo/add',
      remove: 'artigo/remove',
      change: 'artigo/edit',
      get: 'artigo/get',
      getList: 'artigo/list'
    }),
    async reload () {
      await this.getList(this.filtros)
    },
    goToPage (page) {
      this.filtros.page = page
      this.getList(this.filtros)
    },
    async edita (item) {
      let form = await this.get(item.id)
      this.titulo = `Edita Titulo - ${form.titulo}`
      let { id, titulo, chamada, conteudo, tipo, tags } = form
      let urlVideo = form.url_video
      let linkOrcamentoId = form.link_orcamento_id
      let arquivoId = form.arquivo_id
      let arquivo = form.arquivo
      let seoTitle = form.seo_title
      let seoDescription = form.seo_description
      let seoKeywords = form.seo_keywords
      if (tags && tags.map) {
        tags = tags.map(e => {
          return { id: e.id, nome: e.nome }
        })
      }
      this.form = {
        id,
        titulo,
        chamada,
        conteudo,
        tipo,
        arquivo: arquivo,
        link_orcamento_id: linkOrcamentoId,
        arquivo_id: arquivoId,
        url_video: urlVideo,
        seo_title: seoTitle,
        seo_description: seoDescription,
        seo_keywords: seoKeywords,
        tags
      }
    },
    async exclui (item) {
      if (confirm('Deseja mesmo excluir essa artigo?')) {
        try {
          await this.remove(item.id)
          await this.reload()
        } catch (e) {
          if (e.response) {
            alert(e.response.data.message)
          } else alert(e.message)
        }
      }
    },
    async novoArquivo (arquivo) {
      await this.getArquivos()
      this.form.arquivo_id = arquivo.id
    },
    async adicionaImagemConteudo (file, Editor, cursorLocation) {
      let data = new FormData()
      data.append('file', file)
      let arquivo = await this.addArquivo(data)
      Editor.insertEmbed(cursorLocation, 'image', `${this.url}arquivo/view/${encodeURIComponent(arquivo.nome)}${arquivo.extensao}`)
    },
    changeTipo () {
      if (this.form.tipo === 'imagem') this.form.url_video = null
      else if (this.form.tipo === 'video') this.form.arquivo_id = null
    },
    async salva () {
      let form = JSON.parse(JSON.stringify(this.form))
      // Traga Tags
      if (form.tags && form.tags.map) {
        form.tags = form.tags.map(e => e.id)
      }
      try {
        if (!form.id) await this.add(form)
        else await this.change(form)
        await this.reload()
        this.cancela()
      } catch (e) {
        if (e.response) {
          alert(e.response.data.message)
        } else alert(e.message)
      }
    },
    cancela () {
      this.titulo = 'Novo Artigo'
      this.form = {
        tipo: 'imagem',
        link_orcamento_id: null,
        arquivo_id: null,
        url_video: null,
        conteudo: '',
        tags: []
      }
    }
  }

}
</script>

<template>
  <div class="crud">
    <div class="columns">
      <div class="column">
        <div class="card">
          <div class="card-content">
            <h4>Todos as artigos</h4>
            <form @submit.prevent="getList(filtros)">
              <div class="field is-horizontal filtros">
                <div class="field-body">
                  <div class="field">
                    <p class="control is-expanded">
                      <input class="input" type="text" placeholder="Digite a busca" v-model="filtros.q">
                    </p>
                  </div>
                  <div class="field is-grouped">
                    <div class="control is-expanded">
                      <button class="button is-link is-info" type="submit"><i class="fa fa-search"></i></button>
                    </div>
                  </div>
                </div>
              </div>
            </form>
            <table class="table is-bordered is-narrow is-fullwidth mt-10">
              <thead>
                <tr>
                  <th><abbr title="Codigo">#</abbr></th>
                  <th>Tipo</th>
                  <th>Nome</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(item, indice) in list" :key="indice">
                  <td>{{ item.id }}</td>
                  <td>{{ item.tipo }}</td>
                  <td>{{ item.titulo }}</td>
                  <td class="actions">
                    <button class="button is-small is-warning" @click="edita(item)"><i class="fa fa-pencil-alt"></i></button>
                    <button class="button is-small is-danger" @click="exclui(item)"><i class="fa fa-trash"></i></button>
                  </td>
                </tr>
              </tbody>
            </table>
            <nav class="pagination">
              <ul class="pagination-list">
                <li v-if="paginate.dots_prev"><a class="pagination-link" @click="goToPage(paginate.firstPage)">{{ paginate.firstPage }}</a></li>
                <li v-if="paginate.dots_prev"><span class="pagination-ellipsis">&hellip;</span></li>
                <li v-for="(item, indice) in paginate.list" :key="indice">
                  <a class="pagination-link" @click="goToPage(item)" :class="{ 'is-current': item === paginate.page }">{{ item }}</a>
                </li>
                <li v-if="paginate.dots_next"><span class="pagination-ellipsis">&hellip;</span></li>
                <li v-if="paginate.dots_next"><a class="pagination-link" @click="goToPage(paginate.lastPage)">{{ paginate.lastPage }}</a></li>
              </ul>
            </nav>
          </div>
        </div>
      </div>
      <div class="column">
        <div class="card">
          <div class="card-content">
            <h4>{{ titulo }}</h4>
            <form @submit.prevent="salva">
              <div class="field">
                <label class="label">Titulo</label>
                <div class="control">
                  <input class="input" type="text" placeholder="Digite o titulo do blog" v-model="form.titulo">
                </div>
              </div>
              <div class="field">
                <label class="label">Chamada</label>
                <div class="control">
                  <textarea class="input chamada-artigo" v-model="form.chamada" rows="3"></textarea>
                </div>
              </div>
              <div class="content">
                <div class="seo-content">
                  <div class="field">
                    <label class="label">SEO Title</label>
                    <div class="control">
                      <input class="input" type="text" placeholder="Digite o titulo do blog" v-model="form.seo_title">
                    </div>
                  </div>
                  <div class="field">
                    <label class="label">SEO Description</label>
                    <div class="control">
                      <textarea class="input chamada-artigo" v-model="form.seo_description" rows="3"></textarea>
                    </div>
                  </div>
                  <div class="field">
                    <label class="label">SEO Keywords <small>(Separada por vírgulas)</small></label>
                    <div class="control">
                      <textarea class="input chamada-artigo" v-model="form.seo_keywords" rows="3"></textarea>
                    </div>
                  </div>
                </div>
              </div>
              <div class="columns">
                  <div class="column is-one-third">
                    <div class="field">
                      <label class="label">Tipo</label>
                      <div class="control">
                        <select class="input" v-model="form.tipo">
                          <option value="">Selecione o tipo</option>
                          <option value="imagem">Imagem</option>
                          <option value="video">Vídeo</option>
                        </select>
                      </div>
                    </div>
                  </div>
              </div>
              <div v-if="form.tipo === 'imagem'">
                <div class="columns">
                  <div class="column">
                    <div class="field">
                      <label class="label">Imagem</label>
                      <div class="control">
                        <select class="input" v-model="form.arquivo_id">
                          <option value="">Selecione o arquivo</option>
                          <option :value="item.id" v-for="(item, indice) in arquivos" :key="indice">{{ item.nome }}{{ item.extensao }}</option>
                        </select>
                      </div>
                    </div>
                    <add-file @salvo="novoArquivo" />
                  </div>
                  <div class="column">
                    <div v-if="form.arquivo_id && form.arquivo_id !== ''" class="preview-image">
                      <img :src="`${url}arquivo/view/${encodeURIComponent(form.arquivo.nome)}${form.arquivo.extensao}`">
                    </div>
                  </div>
                </div>
              </div>
              <div v-else-if="form.tipo === 'video'" class="field">
                <label class="label">URL Vídeo</label>
                <div class="control">
                  <input class="input" type="text" placeholder="Digite o link do video" v-model="form.url_video">
                </div>
              </div>
              <div class="field mt-10">
                <label class="label">Tags</label>
                <div class="control">
                  <vue-multiselect v-model="form.tags" :multiple="true" :options="listTags" track-by="nome" label="nome" placeholder="Selecione uma tag"/>
                </div>
              </div>
              <div class="field">
                <label class="label">Link Orçamento</label>
                <div class="control">
                  <select class="input" v-model="form.link_orcamento_id">
                    <option value="">Selecione o link</option>
                    <option :value="item.id" v-for="(item, indice) in links" :key="indice">{{ item.nome }}</option>
                  </select>
                </div>
              </div>
              <div class="field mt-10">
                <label class="label">Conteúdo</label>
                <div class="control" ref="divEditor">
                  <vue-editor
                    v-model="form.conteudo"
                    useCustomImageHandler
                    @imageAdded="adicionaImagemConteudo"
                    :editorToolbar="editorToolbar"
                    ref="editor"
                  />
                </div>
              </div>
              <div class="field is-grouped mt-10">
                <div class="control">
                  <button class="button is-link is-success" type="submit">Salvar</button>
                </div>
                <div class="control">
                  <button class="button is-text" type="button" @click="cancela">Cancelar</button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<style>
  label.label small {
    font-weight: normal;
    font-size: 12px;
  }
  .card-content .content {
    border-radius: 6px;
  }
  .seo-content {
    width: 100%;
    padding: 10px;
  }
  .mt-5px {
    margin-top: 5px;
  }
  .mt-10 {
    margin-top: 10px;
  }
  .crud {
    width: 100%;
    text-align: left;
    margin:10px;
  }
  .crud .table {
    margin: 0px;
    margin-top: 15px;
  }
  .crud .table tr {
    height: 30px;
  }
  .crud .table thead th {
    font-weight: bold;
  }
  .crud .table thead th, .crud .table tbody td {
    padding: 5px !important;
  }
  .crud .table tbody td.actions {
    text-align: center
  }
  .crud .table tbody td.actions button {
    margin-right: 5px;
  }
  .pagination .pagination-list {
    margin: 0px
  }
  .pagination .pagination-list li {
    list-style: none;
  }
  .control input, .control select, .control textarea {
    border: 1px solid #dbdbdb;
  }
  .control .chamada-artigo {
    min-height: 80px;
  }
  .ql-showHtml:after {
    content: "[html]";
  }
</style>
